import { KYMW5002Model } from '../kymw5002.model';
import { GetUseRecordImageListModel } from '../vo/get-use-record-image-list.model';
import { Injectable } from "@angular/core";
import { PlessHttp } from '../../../../shared/http/pless-http.service';
import { PlessDialogServiceSub } from '../../../../commons/kymw00/pless-dialog-service-sub';
import { PlessJsonResponderSub } from 'src/app/commons/kymw00/pless-json-responder-sub.service';
import { PlessRequest } from 'src/app/shared/vo/pless-request.model';

/**
 * 使用履歴画像リスト取得
 *
 * @export
 * @class GetUseRecordImageListService
 * @extends {PlessResponderSub}
 */
@Injectable()
export class KYMW50getUseRecordImageListService extends PlessJsonResponderSub<any> {

  private model: KYMW5002Model = null;
  private vo: GetUseRecordImageListModel = null;

  constructor(
    protected plessHttp: PlessHttp,
    protected dialogService: PlessDialogServiceSub
  ) {
    super(plessHttp, dialogService);
  }

  /**
   * bodyにセットする値を返す
   *
   * @private
   * @returns {PlessRequest} リクエストJSON
   * @memberof GetUseRecordImageListService
   */
  private getBody(): PlessRequest {
    return new PlessRequest({
      parameter: {
        OrderCode: this.vo.orderCode,
        MediumType: this.vo.mediumType,
        CoopCode: this.vo.coopCode,
        Pcode: this.vo.pcode,
        ThisOrderCode: this.vo.thisOrderCode,
      }
    })
  }

  /**
   * API呼び出し
   *
   * @param {KYMW5002Model} model
   * @param {GetUseRecordImageListModel} vo
   * @memberof GetUseRecordImageListService
   */
  execute(model: KYMW5002Model, vo: GetUseRecordImageListModel) {
    this.model = model;
    this.vo = vo;
    this.send('KYMW50getUseRecordImageList', this.getBody());
  }

  /**
   * API通信成功時の処理
   *
   * @param {*} data レスポンスデータ
   * @memberof GetUseRecordImageListService
   */
  success(data: any) {
    this.model.updateUseHistoryImageList(data);
  }
}
